import * as R from 'ramda';
import { ValidatorUtils } from './utils';

export const doubleValidator = {
    validate: (v: any, args: any) => {
        const value = R.is(Object, v) ? v.value : v;
        const decimals = args.length > 0 ? args[0] : '*';
        const separator = args.length > 1 ? args[1] : '.';

        if (value === null || value === undefined || value === '') {
            return {
                valid: false,
            };
        }
        if (Number(decimals) === 0) {
            return {
                valid: /^[-+]?\d+(\.\d+)?([eE][+-]\d+)?$/.test(value),
            };
        }
        const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
        const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[+-]?\\d+)?$`);

        return {
            valid: regex.test(value),
        };
    },
    message(field: string, args: any) {
        if (!isNaN(args[0]) && Number(args[0]) > 0) {
            return `'${ValidatorUtils.prettifyName(field)}' must have at most ${args[Object.keys(args)[0]]} decimals`;
        }
        return `'${ValidatorUtils.prettifyName(field)}' must be a double`;
    },
};
